import { HTMLAttributes } from 'react';
import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  elevation?: 0 | 1 | 2 | 3 | 4 | 5;
  noPadding?: boolean;
  border?: boolean;
  rounded?: 'sm' | 'md' | 'lg' | '4xl' | 'none';
}

function Card({ elevation = 1, noPadding, rounded, border, className, ...rest }: CardProps) {
  return (
    <div
      className={twMerge(
        'card bg-white',
        classNames({
          ' ': elevation === 0,
          'shadow-sm': elevation === 1,
          shadow: elevation === 2,
          'shadow-md': elevation === 3,
          'shadow-lg': elevation === 4,
          'shadow-xl': elevation === 5,
          'p-0': noPadding,
          'p-3': !noPadding,
          'rounded-sm': !rounded || rounded === 'sm',
          'rounded-md': rounded === 'md',
          'rounded-lg': rounded === 'lg',
          'rounded-4xl': rounded === '4xl',
          'border border-charcoal-200': border,
        }),
        className,
      )}
      {...rest}
    />
  );
}

export default Card;
